import React, { useEffect, useState } from 'react';
import Input from './FormElements/Input';
import { Button } from './Button';
import { TrashIcon } from '@phosphor-icons/react';
import { DlpRegex } from '../../Types/StoreTypes';

interface EditableListProps {
    itemValue: string | DlpRegex;
    placeholder: string;
    labelPlaceholder?: string;
    index: number;
    useLabel?: boolean;
    handleChange: (index: number, value?: string, label?: string) => void;
    handleRemove: (index: number) => void;
}

export default function EditableList({
    itemValue,
    placeholder,
    labelPlaceholder = '',
    index,
    useLabel,
    handleChange,
    handleRemove,
}: EditableListProps) {
    const [label, setLabel] = useState('');
    const [regex, setRegex] = useState('');

    useEffect(() => {
        if (typeof itemValue === 'object' && itemValue !== null) {
            setLabel((itemValue as DlpRegex).label || '');
            setRegex((itemValue as DlpRegex).regex || '');
        } else if (typeof itemValue === 'string') {
            if (!useLabel) {
                setRegex(itemValue);
                return;
            }

            try {
                const parsed = JSON.parse(itemValue);
                if (parsed && typeof parsed === 'object') {
                    setLabel(parsed.label || '');
                    setRegex(parsed.regex || '');
                } else {
                    setRegex(itemValue);
                }
            } catch {
                setRegex(itemValue);
            }
        }
    }, [itemValue, useLabel]);

    return (
        <div>
            <div key={index} className="flex w-full gap-6 mb-3">
                {useLabel && (
                    <Input
                        inputType="text"
                        value={label}
                        className="flex-2"
                        onChange={(value) => {
                            setLabel(value);
                            handleChange(index, undefined, value);
                        }}
                        placeholder={`${labelPlaceholder} ${index + 1}`}
                        classList="flex-grow"
                    />
                )}
                <Input
                    inputType="text"
                    value={regex}
                    className="flex-1"
                    onChange={(value) => {
                        setRegex(value);
                        handleChange(index, value, undefined);
                    }}
                    placeholder={`${placeholder} ${index + 1}`}
                    classList="flex-grow"
                />

                <Button variant="secondaryBigRound" className="ml-3" onClick={() => handleRemove(index)}>
                    <TrashIcon size={24} />
                </Button>
            </div>
        </div>
    );
}
